<template>
	<div class="quantification">
		<!-- 量化 -->
		<!-- <common-head :isReturn="false" :title="$t('system.quant')" :is-return="true"></common-head> -->
		<van-nav-bar :title="$t('system.quant')" safe-area-inset-top fixed z-index="9999" ref="vanNavBar" />
		<div class="g_safe_top">
			<div class="menu_head">
				<div class="menu_list">
					<div class="menu_item0" @click="show_xiala(0)">
						<div class="txt" :class="{ on: dian_number == 0 || dian_number == null }">{{ exchange_filter(exchange) }}</div>
						<img src="../../assets/imgs/icon/menu_xiala.png" v-if="dian_number == 0 || dian_number == null">
						<img src="../../assets/imgs/icon/menu_no_xiala.png" v-else>
					</div>
					<div class="menu_item1" @click="show_xiala(1)">
						<div class="txt" :class="{ on: dian_number == 1 || dian_number == null }">{{ fangshi_filter(fangshi) }}</div>
						<img src="../../assets/imgs/icon/menu_xiala.png" v-if="dian_number == 1 || dian_number == null">
						<img src="../../assets/imgs/icon/menu_no_xiala.png" v-else>
					</div>
					<div class="menu_item2" @click="show_xiala(2)">
						<div class="txt" :class="{ on: dian_number == 2 || dian_number == null }">{{ $t('system.' + type) }}</div>
						<img src="../../assets/imgs/icon/menu_xiala.png" v-if="dian_number == 2 || dian_number == null">
						<img src="../../assets/imgs/icon/menu_no_xiala.png" v-else>
					</div>
				</div>
				<div class="xiala_msg" v-if="dian_number == 0">
					<div class="xiala_list">
						<div class="xiala_item" :class="{ on: exchange === 'bitrocket' }" @click="exchange_select('bitrocket')">{{ $t('system.bitrocket') }}</div>
						<div class="xiala_item" :class="{ on: exchange === 'okex' }" @click="exchange_select('okex')">{{ $t('system.OKEx') }}</div>
						<div class="xiala_item" :class="{ on: exchange === 'bian' }" @click="exchange_select('bian')">{{ $t('system.bian') }}</div>
						<div class="xiala_item" :class="{ on: exchange === 'huobi' }" @click="exchange_select('huobi')">{{ $t('system.huobi') }}</div>
					</div>
				</div>
				<div class="xiala_msg" v-if="dian_number == 1">
					<div class="xiala_list">
						<div class="xiala_item" v-for="(item, index) in menuList" :key="index" :class="{ on: fangshi == item.value }" @click="jiaoyi_select(item.value)">{{ jiaoyileixing(item.name) }}</div>
					</div>
				</div>
				<div class="xiala_msg" v-if="dian_number == 2 && fangshi == 1">
					<div class="xiala_list">
						<div class="xiala_item" v-for="(item, index) in strategy_children" :key="index" :class="{ on: type === item.value }" @click="type_select(item.value)">{{ $t('system.' + item.value) }}</div>
					</div>
				</div>
				<div class="xiala_msg" v-if="dian_number == 2 && fangshi == 2">
					<div class="xiala_list">
						<div class="xiala_item" v-for="(item, index) in strategy_children1" :key="index" :class="{ on: type === item.value }" @click="type_select(item.value)">{{ $t('system.' + item.value) }}</div>
					</div>
				</div>
				<div class="menu_zhuangtai">
					<span class="tai_item" :class="{ on: state === 'all' }" @click="state_select('all')">{{ $t('system.all') }}</span>
					<span class="tai_item" :class="{ on: state === 'running' }" @click="state_select('running')">{{ $t('system.running') }}</span>
					<span class="tai_item" :class="{ on: state === 'stopped' }" @click="state_select('stopped')">{{ $t('system.stop') }}</span>
					<span class="tai_item" :class="{ on: state === 'popular' }" @click="state_select('popular')">{{ $t('system.unconfig') }}</span>
				</div>
			</div>
			<!-- <div class="menuQuan">
				<div class="filterBox">
					<div class="menuLine">
						<span class="menuItem" :class="{ on: exchange === 'huobi' }" @click="exchange_select('huobi')">HUOBI</span>
						<span class="menuItem" :class="{ on: exchange === 'bian' }" @click="exchange_select('bian')">BINANCE</span>
						<span class="menuItem" :class="{ on: exchange === 'okex' }" @click="exchange_select('okex')">OKX</span>
						<span class="menuItem" :class="{ on: exchange === 'uniswap' }" @click="exchange_select('uniswap')">UNISWAP</span>
					</div>
					<div class="menuLine">
						<span v-for="(item, index) in menuList" :key="index" class="menuItem1" :class="{ on: fangshi == item.value }" @click="jiaoyi_select(item.value)">
							{{ jiaoyileixing(item.name) }}
						</span>
					</div>
					<div class="menuLine" v-if="fangshi == 1">
						<span v-for="(item, index) in strategy_children" :key="index" class="menuItem1" :class="{ on: type === item.value }" @click="type_select(item.value)">
							{{ $t('system.' + item.value) }}
						</span>
					</div>
					<div class="menuLine" v-if="fangshi == 2">
						<span v-for="(item, index) in strategy_children1" :key="index" class="menuItem1" :class="{ on: type === item.value }" @click="type_select(item.value)">
							{{ $t('system.' + item.value) }}
						</span>
					</div>
					<div class="menuLine" style="justify-content: space-between;margin: 0 0.2rem;">
						<span class="menuItem menuBlock" :class="{ on: state === 'all' }" @click="state_select('all')">{{ $t('system.all') }}</span>
						<span class="menuItem menuBlock" :class="{ on: state === 'running' }" @click="state_select('running')">{{ $t('system.running') }}</span>
						<span class="menuItem menuBlock" :class="{ on: state === 'stopped' }" @click="state_select('stopped')">{{ $t('system.stop') }}</span>
						<span class="menuItem menuBlock" :class="{ on: state === 'popular' }" @click="state_select('popular')">{{ $t('system.unconfig') }}</span>
					</div>
				</div>
			</div> -->

			<div style="background-color:#fff;padding:20px 10px;margin:10px 0">
				<searchCom style="margin-bottom:16px" :placeholder="$t('system.Pleaseentercurrency')" @onSearch="handleSearch" />
				<div class="header">
					<div class="title">{{ $t('system.currency') }}</div>
					<div class="right2">{{ $t('system.new_price') }}</div>
					<div class="right1">{{ $t('system.Up') }}</div>
				</div>
			</div>
			<div class="list">
				<van-checkbox-group v-model="check_bot_set" ref="checkboxGroup">
					<!-- 主板-主区 -->
					<robot-list
						v-if="zone_1_list.length > 0"
						:title="$t('system.MotherboardMainarea')"
						:list="zone_1_list"
						:exchange="exchange"
						:type="type"
						@change="onListChange"
						:fangshi="fangshi"
					/>
					<!-- 创新区 -->
					<robot-list
						v-if="zone_2_list.length > 0"
						:title="$t('system.InnovationZone')"
						:list="zone_2_list"
						:exchange="exchange"
						:type="type"
						@change="onListChange"
						:fangshi="fangshi"
					/>
					<robot-list v-if="zone_3_list.length > 0" title="ETF" :list="zone_3_list" :exchange="exchange" :type="type" @change="onListChange" :fangshi="fangshi" />
					<robot-list v-if="zone_4_list.length > 0" title="DeFI" :list="zone_4_list" :exchange="exchange" :type="type" @change="onListChange" :fangshi="fangshi" />
					<robot-list v-if="zone_5_list.length > 0" title="ETP" :list="zone_5_list" :exchange="exchange" :type="type" @change="onListChange" :fangshi="fangshi" />
				</van-checkbox-group>
			</div>

			<!-- 		<div class="setup">
						<span @click="batchTan()">< {{ $t('system.Batchsettings') }}</span>
						{{ $t('system.Usdtavailable') }}:{{ balance }}
					</div> -->
			<van-popup v-model="show" position="bottom" round :style="{ height: '20%', backgroundColor: '#FFF' }">
				<div class="tan">
					<div class="tan_header">
						<div class="tan_header_txt">{{ $t('system.piliangtankuang') }}</div>
					</div>
					<div class="tan_content">
						<div class="tan_item" @click="batchSet()">
							<div class="img0"><img src="@/assets/imgs/new_color/piliang.png" /></div>
							<div class="tan_item_txt">{{ $t('system.Batchsettings') }}</div>
						</div>
						<div class="tan_item" @click="batchtingzhi()">
							<div class="img"><img src="@/assets/imgs/new_color/tingzhi.png" /></div>
							<div class="tan_item_txt">{{ $t('system.Batch_stop') }}</div>
						</div>
						<div class="tan_item" @click="show0 = true">
							<div class="img"><img src="@/assets/imgs/new_color/qingcang.png" /></div>
							<div class="tan_item_txt">{{ $t('system.Bulk_clearing') }}</div>
						</div>
					</div>
				</div>
			</van-popup>
			<van-popup class="setResultWin" v-model="show1">
				<div v-if="isstop">{{ $t('system.successNumber') }}：{{ succ_num }}</div>
				<div v-else>{{ $t('system.successNumber') }}：{{ succ_num.length }}</div>
				<div v-if="isstop">{{ $t('system.failNumber') }}：{{ error_num }}</div>
				<div v-else>{{ $t('system.failNumber') }}：{{ error_num.length }}</div>
			</van-popup>
			<!-- 批量清仓2次确认 -->
			<van-dialog v-model="show0" title="提示" show-cancel-button message="是否确认批量清仓?" @confirm="yes0"></van-dialog>
			<van-dialog
				v-model="isShowPoster"
				show-cancel-button
				:title="$t('system.fxtishi')"
				:message="xieyi_content"
				@confirm="yes"
				:confirmButtonText="$t('system.agree')"
				confirmButtonColor="#5899F6"
				:cancelButtonText="$t('system.refuse')"
				cancelButtonColor="#D98181"
				messageAlign="left"
			></van-dialog>
		</div>
		<div class="zichan">
			<van-checkbox v-model="checked" @click="checkAll(checked)">
				<template #icon="props">
					<span class="checkboxIco" :class="{ on: props.checked }"></span>
				</template>
				<span class="quanxuan">{{ $t('system.allchecked') }}</span>
			</van-checkbox>
			<div class="z_left">{{ $t('system.Usdtavailable') }}: {{ balance }}</div>
			<div class="z_right" @click="batchTan()">
				<div class="txt">{{ $t('system.Batchsettings') }}</div>
				<div class="img"><img src="../../assets/imgs/icon/q_in.png" ></div>
			</div>
		</div>
		<van-tabbar v-model="active" active-color="#EFBA0D" inactive-color="#ACB5BC" route safe-area-inset-bottom>
			<van-tabbar-item replace to="/">
				<span>{{ $t('common.home') }}</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/imgs/new_color/home_a.png" />
					<img v-else src="../../assets/imgs/new_color/home.png" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/quantification">
				<span>{{ $t('system.quant') }}</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/imgs/new_color/lianghua_a.png" />
					<img v-else src="../../assets/imgs/new_color/lianghua.png" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item replace to="/my">
				<span>{{ $t('xinzeng.wode') }}</span>
				<template #icon="props">
					<img v-if="props.active" src="../../assets/imgs/new_color/my_a.png" />
					<img v-else src="../../assets/imgs/new_color/my.png" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
		<van-overlay :show="zhe_show" @click="zhezhao()" z-index="98" class-name="zhezhao"></van-overlay>
	</div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import _ from 'lodash';
import commonHead from '@/components/commonHead';
import asideLeft from '@/components/asideLeft';
import RobotList from './components/RobotList.vue';
import search from '@/components/search';
import { Overlay } from 'vant';
Vue.use(Overlay);

export default {
	components: {
		commonHead,
		asideLeft,
		RobotList,
		searchCom: search
	},
	name: 'quantification',
	// props: {
	// 	exchange: {
	// 		type: String,
	// 		default: 'huobi'
	// 	}
	// },
	data() {
		return {
			active: 1,
			xieyi_content:
				'\n尊敬的用户：\n\n本产品是一款辅助交易的工具类产品，如果您是位于以下国家/地区的公民或居民，在以下国家/地区设立或以其他方式成立，则不得访问或使用本服务或交易平台：（i）美国，加拿大安大略省，加拿大魁北克省，中华人民共和国大陆,  中华人民共和国香港/澳门/台湾地区，塞舌尔共和国，百慕大，布隆迪，中非共和国，刚果民主共和国，厄立特里亚，几内亚比绍，利比亚，马里，巴勒斯坦，索马里，南苏丹，西撒哈拉，也门，古巴，克里米亚和塞瓦斯托波尔，伊朗，叙利亚，朝鲜或苏丹；(ii) 根据您的适用法律（由于您的国籍，住所，公民身份，居住地或其他原因）访问或使用服务或交易平台是非法的司法管辖区。用户本人应在确保完全理解本协议全部条款基础上审慎决定,一经勾选选择表示用户完全同意则本协议生效。\n\n\n前言\n\n鉴于投资风险的存在,在确认本协议及进行合约交易前, 投资者应该仔细阅读本风险提示书，必须确保自己理解有关合约交易的性质、规则,并依据自身的投资经验、目标、财务状况、承担风险的能力等自行决定是否参与合约交易。\n\n\n适合的投资者\n\n合约交易具有高杠杆性和高风险性,仅适合专业投资机构或投资经验丰富的人士,或者能够充分理解有关于数字资产衍生品交易的一切风险,能承受因投资失误而造成账户资金部分或者全部损失的人士。\n\n\n存在的风险\n\n1、价格波动的风险\n\n合约交易作为一种特殊的具有投资价值的产品, 其价格受多种因素的影响,价格波动大,投资者在实际操作中难以全面把握,因而存在出现投资失误的可能性,如果不能有效控制风险,则可能遭受较大的损失,投资者必须独自承担由此导致的一切损失。\n\n\n2、交易风险\n\n投资者需要了解合约交易具有高杠杆的特点,可能导致快速的盈利或者亏损。若交易的方向和行情的波动相反,会造成较大的亏损。根据亏损的程度,投资者需要追加数字货币保证金或者减少仓位,否则其持仓可能会被强制平仓（爆仓），投资者必须承担由此造成的全部损失。\n\n\n提示\n\n1、投资者在参与之前务必详尽地了解数字货币合约交易的基本知识和相关风险。\n\n2、本风险提示书上述风险事项仅为列举性质,未能详尽的列明有关合约交易的所有风险因素,投资者参与合约交易投资前,还应该认真对其它可能存在风险因素有所了解和掌握。\n\n3、我们诚挚的希望和建议投资者,从风险承受能力等自身实际情况出发,审慎的决定是否参与此合约交易,合理地配置自己的数字资产。\n\n\n同意本协议则表明：\n\n1. 投资者已经充分了解数字货币合约交易的基本知识和相关风险。\n\n2. 明确产品内所有操作均为自愿，悉知本产品作为辅助交易工具，不对投资者做出获利保证, 不与投资者共担风险，不对投资者盈亏负任何责任。',
			isShowPoster: false,
			checked: false,
			dian_number: null,
			show0: false, //批量清仓2次确认对话框
			zhe_show: false,
			isagree: 0,
			fangshi1: null,
			jiaoyiLX: 'spot',
			menuList: [],
			strategy_children: [],
			strategy_children1: [],
			fangshi: 1,
			isstop: false,
			new_bot_set: [],
			succ_num: 0, //保存成功个数
			error_num: 0, //保存失败个数
			show1: false,
			show: false,
			type: 'wave', //策略----wangge:智能马丁；wangge2:底部追踪 wave:海浪网格
			exchange: 'huobi', //交易所，huobi，bian，okex，uniswap
			state: 'all', //状态：全部all，运行中running，已停止stopped，未配置unconfig
			value: '', //搜索输入框值
			balance: 0, //账户可用余额
			// 5个区域-量化列表
			zone_1_list: [],
			zone_2_list: [],
			zone_3_list: [],
			zone_4_list: [],
			zone_5_list: [],

			// typeChoiceSet: [{ name: '智能马丁策略' }, { name: '底部追踪策略' }],
			// exchangeChoiceSet: [{ name: '火必' }, { name: '币安' }],
			// bot_list: [],
			// total: 0,
			bot_map: [],
			check_bot_set: [],

			// ----20200411[start]---------
			asideShow: false,
			// 交易所类型
			exchangeMap: {
				huobi: 1,
				bian: 2,
				okex: 3,
				// uniswap: 4,
				bitrocket:4
			},
			tab_index: 1
		};
	},
	created() {
		// console.log(this.$route);
		// let exchange = localStorage.getItem('exchange');
		// let type = localStorage.getItem('type');

		// if (type != 'undefined' && type != null && type) {
		// 	this.type = type;
		// }
		// if (exchange != 'undefined' && exchange != null && exchange) {
		// 	this.exchange = exchange;
		// }

		// this.getStrategySetConfig();
		// this.getAssets();
		// 获取默认交易所信息
		let userinfo = JSON.parse(localStorage.getItem('userInfo'));
		this.exchange = userinfo.default_exchange;

		// 获取缓存的头部选项信息
		let info = JSON.parse(localStorage.getItem('head_index_info'));
		console.log(info);
		if (info != null) {
			this.exchange = info.exchange;
			this.fangshi = info.fangshi;
			this.type = info.type;
			this.state = info.state;
		}

		this.getQuantizationMenu();
		this.search();
		this.getBalance();
		this.isDisplayDealSwap();
		Toast.allowMultiple();
	},
	mounted() {
		console.log(this.$refs.vanNavBar);
		window.addEventListener('beforeunload',()=>{
			// 刷新页面时也更新缓存
			this.updateIndexInfo()
		});
	},
	destroyed() {
		this.updateIndexInfo()
	},
	methods: {
		updateIndexInfo(){
			// if (this.$route.path == '/circularStrategy' || this.$route.path == '/robotSetup' || this.$route.path == '/robotSelectedSetup') {
				let head_index_info = {
					exchange: this.exchange,
					fangshi: this.fangshi,
					type: this.type,
					state: this.state
				};
				localStorage.setItem('head_index_info', JSON.stringify(head_index_info));
			// } else {
			// 	localStorage.removeItem('head_index_info');
			// }
		},
		checkAll(v) {
			const { checkboxGroup } = this.$refs;
			if (v == true) {
				this.$refs.checkboxGroup.toggleAll({
					checked: true,
					skipDisabled: true
				});
			} else {
				this.$refs.checkboxGroup.toggleAll({
					skipDisabled: true
				});
			}
		},
		exchange_filter(e){
			if(e === 'huobi') {
				return this.$t('system.huobi');
			}else if(e === 'bian') {
				return this.$t('system.bian');
			}else if(e === 'okex') {
				return this.$t('system.OKEx');
			}else if(e === 'bitrocket') {
				return this.$t('system.bitrocket');
			}
		},
		zhezhao() {
			setTimeout(() =>{
				this.zhe_show = false;
				this.dian_number = null;
			},100)
		},
		fangshi_filter(e) {
			if(e == 1) {
				return this.$t('system.xianhuojiaoyi');
			}else if(e == 2) {
				return this.$t('system.heyuejiaoyi')
			}
		},
		show_xiala(e) {
			if(this.dian_number == e) {
				setTimeout(() =>{
					this.dian_number = null;
					this.zhe_show = false;
				},100)
			}else {
				setTimeout(() =>{
					this.zhe_show = true;
					this.dian_number = e;
				},100)
			}
		},
		tab_qie(e) {
			this.tab_index = e;
			if (e == 0) {
				this.$router.push('/newHome');
			} else if (e == 1) {
				this.$router.push('/quantification');
			} else if (e == 2) {
				this.$router.push('/my');
			}
		},
		yes() {
			this.isagree = 1;
			this.isDealSwap();
			this.fangshi = this.fangshi1;
			if (this.fangshi == 2) {
				this.jiaoyiLX = 'swap';
				this.type = this.strategy_children1[0].value;
			} else if (this.fangshi == 1) {
				this.jiaoyiLX = 'spot';
				this.type = this.strategy_children[2].value;
			}
			this.getBalance();
			this.search();
			this.isShowPoster = false;
		},
		jiaoyileixing(e) {
			if (e == '现货') {
				return this.$t('system.xianhuojiaoyi');
			} else if (e == '合约') {
				return this.$t('system.heyuejiaoyi');
			}
		},
		yes0() {
			this.batchQingcang();
		},
		// // 获取资产信息
		// getAssets() {
		//   this.$post2("User/Api/Index/userAsset").then((res) => {
		//     console.log(res);
		//     // 总资产是 amout + frozen

		//     let t = res.USDT.amount + res.USDT.frozen;
		//     // this.assetsDitale = t.toFixed(2);
		//     this.balance = t.toFixed(2);
		//     // let t2 = res.REWARD.amount + res.REWARD.frozen;
		//     // this.rewardData = t2.toFixed(2);
		//     // console.log(typeof res.USDT.amount)
		//     // this.amount =  res.amount
		//     // + res.frozen
		//   });
		// },
		// -------------20200411[start]----------
		// handleAsideToggle() {
		//   this.asideShow = !this.asideShow;
		// },
		// handleAsideHide() {
		//   this.asideShow = false;
		// },
		// -------------20200411[end]----------

		// 停止/启动 成功后，重新加载
		onListChange(e) {
			// console.log(e);
			this.search();
		},
		handleSearch(str) {
			this.value = str;
			this.search();
		},
		// 筛选条件更新后-搜索更新
		search() {
			let toast = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				// message: '加载中...',
				message: this.$t('system.Loading')
			});
			this.$post2('Robot/api/index/searchCurrencyV2', {
				exchange: this.exchange,
				trusteeship_type: this.fangshi,
				type: this.type,
				state: this.state,
				value: this.value
			})
				.then(res => {
					console.log('search', res);
					const arr = _.groupBy(res.list, 'tag');

					this.zone_1_list = arr.MainZone || [];
					this.zone_2_list = arr.SubMainZone || [];
					this.zone_3_list = arr.ETF || [];
					this.zone_4_list = arr.DeFI || [];
					this.zone_5_list = arr.ETP || [];

					// this.total = res.total;
					// this.bot_list = res.list;
					res.list.forEach(item => {
						if (item.bot_id > 0) {
							this.bot_map[item.bot_id] = item.token;
						}
					});
					toast.clear();

					this.$forceUpdate();
				})
				.catch(e => {
					this.$toast.fail(e);
					toast.clear();
				});
		},
		// 切换交易所-huobi/bian/okex/uniswap
		exchange_select(exchange) {
			this.exchange = exchange;
			this.search();
			this.getBalance();
			setTimeout(() =>{
				this.zhe_show = false;
				this.dian_number = null;
			},100)
		},

		jiaoyi_select(e) {
			if (this.isagree == 0) {
				this.isShowPoster = true;
				this.fangshi1 = e;
			} else {
				this.fangshi = e;
				if (e == 2) {
					this.jiaoyiLX = 'swap';
					this.type = this.strategy_children1[0].value;
				} else if (e == 1) {
					this.jiaoyiLX = 'spot';
					this.type = this.strategy_children[2].value;
				}
				this.getBalance();
				this.search();
			}
			setTimeout(() =>{
				this.zhe_show = false;
				this.dian_number = null;
			},100)
			// this.$toast(this.$t("system.kaifazhong"));
			// return;
		},

		// 切换策略类型-智能马丁wangge/底部追踪wangge2
		type_select(type) {
			this.type = type;
			this.search();
			setTimeout(() =>{
				this.zhe_show = false;
				this.dian_number = null;
			},100)
		},

		// 状态切换-全部all/运行中running/已停止stopped/未配置unconfig
		state_select(state) {
			this.state = state;
			this.search();
		},

		// 批量设置--弹框--robotSelectedSetup
		batchTan() {
			if (this.check_bot_set.length > 20) {
				// this.$toast.fail('一次不可操作20个交易对');
				this.$toast.fail(this.$t('system.OnceMaxAction20'));
			} else if (this.check_bot_set.length == 0) {
				// this.$toast.fail('请至少选择一个交易对');
				this.$toast.fail(this.$t('system.SelectOneMore'));
			} else {
				this.show = !this.show;
				// let str = '';
				// this.check_bot_set.forEach(bot_id => {
				// 	str = str + this.bot_map[bot_id] + ',';
				// });
				// this.$router.push({
				// 	path: 'robotSelectedSetup',
				// 	query: {
				// 		exchange: this.exchange,
				// 		type: this.type,
				// 		bot_id_set: this.check_bot_set.toString(),
				// 		botstr: str,
				// 	}
				// });
			}
		},
		batchSet() {
			this.new_bot_set = [];
			this.check_bot_set.forEach(item => {
				this.new_bot_set.push(item.bot_id);
			});
			// console.log(this.new_bot_set.toString())
			let str = '';
			this.new_bot_set.forEach(bot_id => {
				str = str + this.bot_map[bot_id] + ',';
			});
			this.$router.push({
				path: 'robotSelectedSetup',
				query: {
					exchange: this.exchange,
					type: this.type,
					bot_id_set: this.new_bot_set.toString(),
					botstr: str,
					fangshi: this.fangshi
				}
			});
		},

		// 获取交易所可用余额
		getBalance() {
			this.$post2('Robot/Api/Index/getBalance', {
				exchange: this.exchangeMap[this.exchange],
				type: this.jiaoyiLX,
				noToast: true
			})
				.then(res => {
					if (res.USDT.amount !== null) {
						this.balance = res.USDT.amount;
					}
				})
				.catch(e => {
					// this.$toast.fail({
					// 	message: e,
					// 	duration: 3000
					// });
				});
		},
		// 获取量化页面的筛查配置菜单
		getQuantizationMenu() {
			this.$post2('Robot/api/index/getQuantizationMenu', {})
				.then(res => {
					this.menuList = res;
					this.strategy_children = res[0].strategy_children;
					this.strategy_children1 = res[1].strategy_children;
				})
				.catch(e => {
					// this.$toast.fail({
					// 	message: e,
					// 	duration: 3000
					// });
				});
		},
		// 是否展示出“合约”弹出框
		isDisplayDealSwap() {
			this.$post2('Robot/api/index/isDisplayDealSwap', {})
				.then(res => {
					this.isagree = res.is_deal_swap;
				})
				.catch(e => {
					// this.$toast.fail({
					// 	message: e,
					// 	duration: 3000
					// });
				});
		},
		// 关闭弹出框
		isDealSwap() {
			this.$post2('Robot/api/index/isDealSwap  ', {
				is_deal: this.isagree
			})
				.then(res => {})
				.catch(e => {
					// this.$toast.fail({
					// 	message: e,
					// 	duration: 3000
					// });
				});
		},
		batchQingcang() {
			this.isstop = false;
			this.check_bot_set.forEach(item => {
				if (item.state == 0) {
					this.new_bot_set.push(item.bot_id);
				}
			});
			if (!this.new_bot_set.length) {
				return this.$toast.fail(this.$t('system.stopRobotFirst'));
			} else {
				const loading = this.$toast.loading({
					duration: 0, // 持续展示 toast
					forbidClick: true,
					message: this.$t('system.Clearanceing')
				});
				this.$post2('Robot/api/index/batchClearance', {
					bot_id_set: this.new_bot_set.toString()
				})
					.then(res => {
						loading.clear();
						this.succ_num = res.succ;
						this.error_num = res.err_bot_id;
						this.show1 = true;
						this.show = false;
						this.new_bot_set = [];
						this.check_bot_set = [];
						this.search();
						toast.clear();
					})
					.catch(e => {
						loading.clear();
						this.show = false;
						this.new_bot_set = [];
						this.check_bot_set = [];
						// this.$toast.fail({
						// 	message: e,
						// 	duration: 3000
						// });
					});
			}
		},
		batchtingzhi() {
			this.isstop = true;
			const loading = this.$toast.loading({
				duration: 0, // 持续展示 toast
				forbidClick: true,
				message: this.$t('system.Stoping')
			});
			this.check_bot_set.forEach(item => {
				this.new_bot_set.push(item.bot_id);
			});
			this.$post2('Robot/api/index/batchStopOrStart', {
				bot_id_set: this.new_bot_set.toString(),
				state: 0
			})
				.then(res => {
					loading.clear();
					this.succ_num = res.succ;
					this.error_num = res.err;
					this.show1 = true;
					this.show = false;
					this.new_bot_set = [];
					this.check_bot_set = [];
					this.search();
					toast.clear();
				})
				.catch(e => {
					loading.clear();
					this.show = false;
					this.new_bot_set = [];
					this.check_bot_set = [];
					// this.$toast.fail({
					// 	message: e,
					// 	duration: 3000
					// });
				});
		}
	}
};
</script>
<style lang="less" scoped>
.quantification {
	font-family: PingFangSC-Regular;
	padding-bottom: 50px;
	background-color: #f7f7fa;
	.van-checkbox__icon--disabled {
		.checkboxIco {
			background: #ddd;
		}
	}
	.checkboxIco {
	  width: 0.33rem;
	  height: 0.33rem;
	  border: 1px solid #8e8f91;
	  display: inline-block;
	  border-radius: 100px;
		background: #FFFFFF;
		border: 1px solid #EFBA0D;
	}
	.checkboxIco.on {
	  background: #EFBA0D;
	  border: 1px solid #EFBA0D;
		position: relative;
	}
	.checkboxIco.on:before,
	.checkboxIco.on::after {
		content: '';
		height: 9px;
		width: 1.5px;
		border-radius: 10px;
		display: block;
		background: #FFFFFF;
		position: absolute;
		top: 3.5px;
		left: 8.5px;
		transform: rotate(45deg);
		-ms-transform: rotate(45deg);
	}
	.checkboxIco.on::before {
		height: 5px;
		transform: rotate(-45deg);
		-ms-transform: rotate(-45deg);
		position: absolute;
		top: 6px;
		left: 3.5px;
	}
	.setup {
		padding: 0 0.3rem;
		width: 100%;
		overflow: hidden;
		height: 0.54rem;
		line-height: 0.54rem;
		background: #f3f8ff;
		position: fixed;
		left: 0;
		bottom: 0;
		font-size: 0.24rem;
		font-weight: 500;
		color: #3893fb;
		text-transform: capitalize;
		span {
			float: right;
		}
	}
	.van-search {
		padding: 0;
	}

	.van-search__content {
		background: #fff;
		// border: 1px solid #fc9216;
		// border-radius: 100px;
		// height: .6rem;
		height: 0.8rem;
		border-radius: 0.5rem;
		// border: 1px solid #90c4ff;
		padding: 2px 0.2rem;
		-webkit-box-sizing: content-box;
		box-sizing: content-box;

		.van-field__control {
			font-size: 0.28rem;
			height: 0.52rem;
		}
		.van-field__control::-webkit-input-placeholder {
			color: rgb(152, 152, 152);
		}
	}

	.listButton {
		display: flex;
		justify-content: space-between;
		flex-direction: column;
		.buttonSetup {
			border: 1px solid rgb(158, 158, 158);
			color: rgb(158, 158, 158);
			border-radius: 4px;
			background: #fff;
			font-size: 0.2rem;
			width: 0.8rem;
			height: 0.38rem;
			margin-bottom: 0.1rem;
		}
		.buttonStart {
			border-radius: 4px;
			background: #fff;
			font-size: 0.2rem;
			width: 0.8rem;
			height: 0.38rem;
		}
		.buttonStart,
		.buttonNone,
		.buttonStop {
			border: 1px solid rgb(252, 151, 40);
			color: rgb(252, 151, 40);
			border-radius: 4px;
			background: #fff;
			font-size: 0.2rem;
			width: 0.8rem;
			height: 0.38rem;
		}
		.buttonStop {
			border: 1px solid rgb(217, 105, 105);
			color: rgb(217, 105, 105);
		}

		.van-button--small {
			width: 0.78rem;
			height: 0.42rem;
			line-height: 0.4rem;
			text-align: center;
			margin-right: 0.27rem;
			border: none;
			padding: 0;
			min-width: 0.77rem;
			border-radius: 5px;

			.van-button__text {
				color: #fff;
				font-size: 0.23rem;
				font-family: PingFang SC;
				font-weight: 500;
			}
		}

		.van-button--small:last-child {
			margin-right: 0;
		}
	}
}
</style>
<style lang="less" scoped>
.change {
	display: flex;
	width: 100%;
	font-size: 0.2rem;
	margin-top: 0.16rem;
}
.itemChange {
	width: 1.4rem;
	color: #888;
	.v {
		margin-left: 3px;
		font-weight: 500;
		font-size: 0.2rem;
		color: #333;
		font-family: Bahnschrift;
	}
}
.content {
	display: flex;
	justify-content: space-between;
	flex-direction: column;
}
.title {
	display: inline;
	border-radius: 5px;
	margin-left: 0.3rem;
	color: rgb(251, 139, 13);
	font-size: 0.26rem;
}
.spe {
	display: inline-block;
	height: 0.2rem;
	border-right: 1px solid #e7e7e7;
	// margin: 0 0.4rem;
}
.menuQuan {
}
.quantification {
	.searchBox {
		// padding-bottom: 0.36rem;
		margin: 0 0.3rem 0.4rem;
	}

	.searchRelative {
		position: relative;

		.searchButton {
			position: absolute;
			right: 0;
			top: 0;
			// width: 1.2rem;
			// background: #fc9216;
			// border-radius: 100px;
			text-align: center;
			font-size: 0.31rem;
			font-weight: 600;
			color: #373737;
			// line-height: 30px;
			// height: 30px;

			width: 1.6rem;
			height: 0.9rem;
			line-height: 0.9rem;
			text-align: center;
			background: #f0f0f0;
			border-radius: 0.5rem;
		}
	}

	.filterBox {
		margin-top: 0.2rem;
		padding: 0.2rem 0.15rem;
		background: #ffffff;
		box-shadow: 0px 2px 18px 0px rgba(202, 202, 202, 0.3);
		padding: 0.2rem 0.57rem 0.2rem 0.61rem;
		border-top-left-radius: 0.32rem;
		border-top-right-radius: 0.32rem;
	}

	.menuLine {
		// margin: 0.33rem 0.245rem 0;
		// padding: 8px 0;
		padding: 0.2rem 0;
		position: relative;
		display: flex;
		.menuName {
			font-size: 0.24rem;
			color: #373737;
			display: inline-block;
			margin-top: 0.03rem;
		}

		.menuItem {
			font-family: PingFangSC-Regular;
			margin-right: 30.5px;
			font-size: 0.28rem;
			color: #8f9eab;
			position: relative;
			text-transform: capitalize;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}
		.menuBlock {
			font-size: 0.24rem;
			border-radius: 4px;
			padding: 3px 6px;
			width: auto !important;
			background-color: #f5f5f5;
			margin-right: 0 !important;
		}
		.menuItem:last-child {
			margin-right: 0;
		}

		.menuItem.on {
			font-family: PingFangSC-Medium;
			// background: #fc9216;
			// color: #90c4ff;
			font-weight: 600;
			font-size: 0.28rem;
			color: #333333;
			// border-right: 1px solid #fc9216;
		}
		.menuItem1 {
			font-family: PingFangSC-Regular;
			margin-right: 0.42rem;
			font-size: 0.28rem;
			color: #8f9eab;
			position: relative;
			text-transform: capitalize;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}

		.menuItem1:last-child {
			margin-right: 0;
		}

		.menuItem1.on {
			font-family: PingFangSC-Medium;
			// background: #fc9216;
			// color: #90c4ff;
			font-weight: 600;
			font-size: 0.28rem;
			color: #333333;
			// border-right: 1px solid #fc9216;
		}
		.menuBlock.on {
			// background-color: #f3f8fe;
			font-family: PingFangSC-Medium;
			color: #333333;
			font-size: 0.24rem;
			font-weight: bold;
		}
		.dropdownBtn {
			color: #3893fb;
			font-size: 0.32rem;
		}
	}

	.listQuan {
		padding-bottom: 1.2rem;
		margin: 0 0.245rem 0;

		li {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 1.39rem;
			border-bottom: 1px solid #e4e7ed;
			.name {
				font-size: 0.28rem;
				font-weight: bold;
				color: #181818;
			}
			.checkbox {
				display: inline-block;
				vertical-align: -0.05rem;
				margin-right: 0.16rem;
			}
		}
	}
}

.list {
	// margin: 0 0.2rem;
	padding-bottom: 1.5rem;
}
.tan {
	margin-top: 0.4rem;
	.tan_header {
		margin-left: 0.3rem;
		display: flex;
		align-items: center;
		.tan_header_biaozi {
			width: 0.1rem;
			height: 0.1rem;
			border-radius: 50%;
			background-color: #373737;
		}
		.tan_header_txt {
			font-family: PingFang SC;
			margin: 0 auto;
			color: #333333;
			font-size: 0.24rem;
		}
	}
	.tan_content {
		padding: 0 0.8rem;
		display: flex;
		justify-content: space-between;
		margin-top: 0.48rem;
		.tan_item {
			// width: 1rem;
			display: flex;
			flex-direction: column;
			align-items: center;
			// background-color: blue;
			.img0 {
				width: 0.55rem;
				height: 0.44rem;
				text-align: center;
				line-height: 0.44rem;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.img {
				width: 0.44rem;
				height: 0.44rem;
				text-align: center;
				line-height: 0.44rem;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.tan_item_txt {
				// font-weight: 600;
				margin-top: 0.2rem;
				width: 100%;
				color: #333333;
				font-size: 0.24rem;
				text-align: center;
			}
		}
	}
}
.setResultWin {
	width: 50%;
	padding: 0.2rem;
	border: 1px solid #eee;
	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);
	border-radius: 3px;

	div {
		padding: 0.1rem;
	}
}
.header {
	background-color: #ffffff;
	border-radius: 0.15rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 0.3rem;
	// padding: 0 0.25rem 0 0.15rem;
}
.title {
	// padding: 0.1rem 0.1rem;
	// border-radius: 5px;
	// margin-left: 0.15rem;
	// width: 33.3%;
	color: #6f7989;
	font-size: 0.28rem;
	font-family: PingFang SC;
}
.right1 {
	color: #6f7989;
	font-size: 0.28rem;
	text-align: right;
}
.right2 {
	margin-left: 0.6rem;
	color: #6f7989;
	font-size: 0.28rem;
	text-align: center;
}
.zichan {
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: fixed;
	left: 0;
	bottom: 1.13rem;
	bottom: calc(env(safe-area-inset-bottom) + 1.13rem);
	border-bottom: 0.01rem solid #F6F6F6;
	height: 0.72rem;
	width: 100%;
	background-color: #FFFFFF;
	padding: 0 0.1rem;
	padding: 0 0.4rem;
	.z_left {
		font-family: PingFangSC-Regular;
		font-size: 0.24rem;
		color: #6F7A8B;
	}
	.z_right {
		display: flex;
		align-content: center;
		.txt {
			font-family: PingFangSC-Regular;
			font-size: 0.24rem;
			color: #EFBA0D;
		}
		.img {
			padding-left: 0.2rem;
			img {
				width: 0.24rem;
				height: 0.24rem;
			}
		}
	}
}
.tab_bottom {
	display: flex;
	justify-content: space-between;
	position: fixed;
	left: 0;
	bottom: 0;
	height: 1.14rem;
	width: 100%;
	background-color: #ffffff;
	border-top: 0.005rem solid #dedede;
	.tab_item {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 0.14rem 0.8rem;
		.logo {
			width: 0.4rem;
			height: 0.4rem;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.logo1 {
			width: 0.32rem;
			height: 0.4rem;
			img {
				width: 100%;
				height: 100%;
			}
		}
		.txt {
			color: #acb5bc;
			margin-top: 0.04rem;
			font-size: 0.24rem;
			transform: scale(0.916);
		}
		.active {
			color: #efba0d;
			font-family: PingFangSC-Medium;
		}
	}
}
.menu_head {
	position: relative;
	z-index: 99;
	background-color: #FFFFFF;
	.menu_list {
		padding: 0.39rem 0.6rem 0.2rem 0.6rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.menu_item0 {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			width: 33.3%;
			.txt {
				color: #6F7989;
				font-size: 0.28rem;
				font-weight: bold;
			}
			.txt.on {
				color: #333333;
			}
			img {
				margin-left: 0.12rem;
				width: 0.16rem;
				height: 0.11rem;
			}
		}
		.menu_item1 {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 33.3%;
			.txt {
				color: #6F7989;
				font-size: 0.28rem;
				font-weight: bold;
			}
			.txt.on {
				color: #333333;
			}
			img {
				margin-left: 0.12rem;
				width: 0.16rem;
				height: 0.11rem;
			}
		}
		.menu_item2 {
			display: flex;
			align-items: center;
			justify-content: flex-end;
			width: 33.3%;
			.txt {
				color: #6F7989;
				font-size: 0.28rem;
				font-weight: bold;
			}
			.txt.on {
				color: #333333;
			}
			img {
				margin-left: 0.12rem;
				width: 0.16rem;
				height: 0.11rem;
			}
		}
	}
	.xiala_msg {
		position: absolute;
		left: 0;
		top: 1rem;
		z-index: 99;
		background-color: #FFFFFF;
		width: 100%;
		.xiala_list {
			padding: 0.2rem 0.24rem 0.2rem 0.24rem;
			display: flex;
			align-items: center;
			// justify-content: space-between;
			flex-wrap: wrap;
			.xiala_item {
				width: 2.18rem;
				height: 0.72rem;
				background-color: #F7F7FA;
				font-size: 0.28rem;
				color: #6F7989;
				text-align: center;
				line-height: 0.72rem;
				margin-bottom: 0.2rem;
				border-radius: 0.08rem;
				margin-right: 0.24rem;
			}
			.xiala_item:nth-child(3) {
				margin-right: 0;
			}
			.xiala_item:nth-child(6) {
				margin-right: 0;
			}
			.xiala_item.on {
				background-color: #E7ECEF;
				color: #333333;
				font-weight: bold;
			}
		}
	}
	.menu_zhuangtai {
		padding: 0 0.8rem;
		padding-top: 0.2rem;
		padding-bottom: 0.4rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		.tai_item {
			background-color: #F7F7FA;
			color: #8F9EAB;
			font-size: 0.24rem;
			padding: 0.06rem 0.24rem;
		}
		.tai_item.on {
			font-weight: bold;
			color: #333333;
		}
	}
}
.zhezhao {
	// top: 15vh;
}
.quanxuan {
	font-size: 0.24rem;
	color: #EFBA0D;
}
</style>
